import { render, staticRenderFns } from "./PageButton.vue?vue&type=template&id=75e54a86&scoped=true&"
import script from "./PageButton.vue?vue&type=script&lang=js&"
export * from "./PageButton.vue?vue&type=script&lang=js&"
import style0 from "./PageButton.vue?vue&type=style&index=0&id=75e54a86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e54a86",
  null
  
)

export default component.exports